import { FormOfTemporaryResidence } from './FormOfTemporaryResidence'
import { AdmissionsCert } from './AdmissionsCert'
import { MedicalExam } from './MedicalExam'
import { JW202 } from './JW202'

export { FormOfTemporaryResidence, JW202, AdmissionsCert, MedicalExam }
